import  { FC, useState, useRef } from "react"
import Button from '@mui/material/Button'
import EventConditionsComponent from "@pages/makeEvent/steps-components/eventConditions-component/index.tsx"
import { ConditionsTabPanelProps } from '@/pages/eventEditing/components/types'


const ConditionsTabPanel: FC<ConditionsTabPanelProps> = ({ formik }) => {
	const { values } = formik
	const initialValues = {}
	const [validFieldsValues, setValidFieldsValues] = useState({initialValues})
	const preservedInitialValues = useRef(initialValues)


	return (
		<div style={{display: 'flex', flexDirection: 'column'}}>
			<EventConditionsComponent formik={formik} />
		</div>
	)
}

export default ConditionsTabPanel